<template>
  <div></div>
</template>

<script>
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'

import GridTable from '@/components/common/GridTable'

@Component({
  components: {
    GridTable
  }
})
export default class BaseList extends Vue {
  componentKey = 0

  title = null

  appendTitle = null

  watchStateSchools = true

  getConfigByColumn(key) {
    return this.columns.find(item => item.field === key)
  }

  getConfigByModel(key) {
    return (
      this.schema &&
      this.schema.fields &&
      this.schema.fields.find(item => item.model === key)
    )
  }

  get filteredBySchool() {
    return (
      (this.stateFilterBySchool && this.stateFilterBySchool.id) ||
      (this.$route.query && this.$route.query.schoolId)
    )
  }

  @Watch('filteredBySchool', { immediate: true })
  onChangeFilterBySchool() {
    if(this.stateFilterBySchool === true) return;
    
    if (!Array.isArray(this.stateSchools)) {
      return false
    }

    const currentSchool = this.stateSchools.find(
      item => item.id === this.filteredBySchool
    )
    this.appendTitle =
      currentSchool && currentSchool.name
        ? ` <i>(School: ${currentSchool.name})</i>`
        : ''

    const colSchool = this.getConfigByColumn('school.name')
    if (colSchool) {
      colSchool.hidden = !!this.filteredBySchool
    }

    this.componentKey++
  }

  @Watch('stateSchools', { immediate: true })
  loadSchoolOptions() {
    if (
      this.watchStateSchools === false ||
      !(this.schema && Array.isArray(this.schema.fields))
    ) {
      return false
    }

    this.schema.fields.find(item => item.model === 'schoolId').values = () => {
      return this.stateSchools
    }

    const filterList = this.stateSchools.map(item => {
      return { value: item.id, text: item.name }
    })

    this.getConfigByColumn(
      'school.name'
    ).filterOptions.filterDropdownItems = filterList
  }

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/BaseList.vue